import { OnInit, Component, Input, Output, OnDestroy, OnChanges, SimpleChanges } from '@angular/core';
import { EventEmitter } from '@angular/core';

@Component({
  selector: 'mtm-assets-dropdown',
  templateUrl: './mtm-assets-dropdown.component.html',
  styleUrl: './mtm-assets-dropdown.component.scss',
  standalone: false,
})
export class MtmAssetsDropdownComponent implements OnInit, OnDestroy {
  @Input() section: any;
  @Input() subSection: any;
  @Input() data: any[] = [];
  @Input() versionData: any;
  @Input() readOnly: boolean = false;

  isSelectAll: boolean = false;
  isOpen: boolean = false;
  component: any = this;
  moreValue: any = 0;
  private readonly clickHandler: (e: Event) => void;

  modelValue: any = [];
  @Input()
  get value() {
    return this.modelValue || [];
  }
  @Output() valueChange: EventEmitter<any> = new EventEmitter();
  set value(val) {
    this.data.forEach((asset) => {
      asset.isSelected = val.filter((selectedAsset) => asset.optionId === selectedAsset.optionId).length > 0;
    });
    this.modelValue = val;
    this.isSelectAll = this.modelValue.length === this.data.length && this.modelValue.length > 0;
  }

  constructor() {
    const component = this;
    this.clickHandler = (e: Event) => {
      const target = e.target as HTMLElement;
      const dropdownComponent = target.closest('.mtm-assets-dropdown');
      if (!dropdownComponent && component.isOpen) {
        component.isOpen = false;
      }
    };
    window.addEventListener('click', this.clickHandler);
  }

  ngOnInit() {
    this.versionData.isExpanded = !!this.value?.length;
    this.versionData.isSelected = !!this.value?.length;
  }

  ngOnDestroy() {
    if (this.clickHandler) {
      window.removeEventListener('click', this.clickHandler);
    }
  }

  toggleDropdown() {
    this.isOpen = !this.isOpen;
  }

  getValueCaptions() {
    if (!this.value.length) {
      return '';
    }
    this.moreValue = 0;
    const firstValue = this.value[0] || {};
    let result =
      firstValue.title ||
      firstValue.name ||
      firstValue.language ||
      firstValue.accessory ||
      firstValue.elementOfSetDesign ||
      firstValue.articleOfCostumeDesign;
    if (this.value.length > 1) {
      for (let i = 1; i < this.value.length - (this.value.length - 2); i++) {
        const secondValue = this.value[i] || {};
        result =
          result +
          ', ' +
          (secondValue.title ||
            secondValue.name ||
            secondValue.language ||
            secondValue.accessory ||
            secondValue.elementOfSetDesign ||
            secondValue.articleOfCostumeDesign);
      }
      this.moreValue = this.value.length - 2;
    }
    return result;
  }

  selectAllAssetsInSubSection() {
    if (this.readOnly) {
      return;
    }
    this.isSelectAll = !this.isSelectAll;
    this.versionData.isSelected = this.isSelectAll;
    this.data.forEach((data) => {
      data.isSelected = this.isSelectAll;
    });
    this.versionData.topics.map((topic) => {
      topic.isSelected = this.isSelectAll;
      topic.assets.map((a) => {
        a.isSelected = this.isSelectAll;
        a.simpleVersions.map((v) => {
          v.isSelected = this.isSelectAll;
          return v;
        });
        return a;
      });
      return topic;
    });
    this.setModelValue();
    this.isSelectAll = this.value.length === this.data.length;
  }

  selectTopicAssets(topic) {
    if (this.readOnly) {
      return;
    }
    topic.isSelected = !topic.isSelected;
    topic.assets.map((a) => {
      a.isSelected = topic.isSelected;
      a.simpleVersions.map((v) => {
        v.isSelected = a.isSelected;
        return a;
      });
      return a;
    });
    this.versionData.isSelected = this.versionData.topics.filter((t) => t.isSelected).length;
    this.setModelValue();
    this.isSelectAll = this.value.length === this.data.length;
  }

  selectAllAsset(topic, asset) {
    if (this.readOnly) {
      return;
    }
    asset.isSelected = !asset.isSelected;
    asset.simpleVersions.map((v) => {
      v.isSelected = asset.isSelected;
      return v;
    });
    topic.isSelected = topic.assets.filter((a) => a.isSelected).length;
    this.versionData.isSelected = this.versionData.topics.filter((t) => t.isSelected).length;
    this.setModelValue();
    this.isSelectAll = this.value.length === this.data.length;
  }

  selectVersionAsset(topic, asset, version) {
    if (this.readOnly) {
      return;
    }
    version.isSelected = !version.isSelected;
    asset.isSelected = asset.simpleVersions.filter((v) => v.isSelected).length;
    topic.isSelected = topic.assets.filter((a) => a.isSelected).length;
    this.versionData.isSelected = this.versionData.topics.filter((t) => t.isSelected).length;
    this.setModelValue();
    this.isSelectAll = this.value.length === this.data.length;
  }

  setModelValue() {
    this.value = this.data.filter((data) => data.isSelected);
    this.valueChange.emit(this.value);
  }
}
